import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <p style={{ fontSize: '0.8rem', textAlign: 'center' }}>
        Immagine di sfondo di{' '}
        <a
          href="https://www.freepik.com/wirestock"
          target="_blank"
          rel="noopener noreferrer"
        >
          Wirestock
        </a>{' '}
        su{' '}
        <a
          href="https://www.freepik.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Freepik
        </a>
        ,{''} Icona creata da{''} <a href="https://www.flaticon.com/free-icons/planet" title="planet icons">Good Ware - Flaticon</a>
      </p>
    </div>
  );
};

export default Footer;
